import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class SmsTemplateRepositoryService {
    constructor() { }

    public get pastUnsignedContractsSmsText(): string {
        return "Tienes un contrato pendiente de firma, por favor pásate urgentemente por nuestra oficina";
    }

    public get pastUnsignedContractsDirectSmsText(): string {
        return "Tienes un contrato pendiente de firma, por favor pásate urgentemente por nuestra oficina";
    }

    public get inmediateUnsignedContractsSmsText(): string {
        return "Hola, te recordamos que tienes un contrato pendiente de firmar. Fírmalo por favor cuanto antes";
    }

    public get inmediateUnsignedContractsDirectSmsText(): string {
        return "Hola, te recordamos que tienes un contrato pendiente de firmar. Fírmalo por favor cuanto antes";
    }
}
